import React, { createContext, useContext, useState } from 'react';

const CartContext = createContext();

export function useCart() {
  return useContext(CartContext);
}

export function CartProvider({ children }) {
  const [cartItems, setCartItems] = useState([]);

  function addToCart(need) {
    setCartItems(prev => {
      if (prev.find(item => item.id === need.id)) return prev;
      return [...prev, need];
    });
  }

  function removeFromCart(needId) {
    setCartItems(prev => prev.filter(item => item.id !== needId));
  }

  function clearCart() {
    setCartItems([]);
  }

  function isInCart(needId) {
    return cartItems.some(item => item.id === needId);
  }

  const cartTotal = cartItems.reduce(
    (sum, item) => sum + (item.pricePerCycle || 0), 0
  );

  return (
    <CartContext.Provider value={{
      cartItems, addToCart, removeFromCart,
      clearCart, isInCart, cartTotal
    }}>
      {children}
    </CartContext.Provider>
  );
}